import { QCNamingConvention } from './qc-naming-convention';

export class QCSAWFilesNamingConvention extends QCNamingConvention {

  get description(): string {
    return "SAW Files";
  }

  get generatedName(): string {
    let name = this.foreignEpisode + '_' + this.videoBitRate + this.videoBitRateUnits + '_' + this.format + '_' + this.aspectRatio + '_' + this.standard + '_' + this.language + '_' + this.version + '_' + this.programTitle;
    if (this.revision != null) {
      name += '_R' + this.revision
    }
    return name;
  }

  static get requiredComponents(): string[] {
    return [
      'aspectRatio',
      'foreignEpisode',
      'format',
      'language',
      'programTitle',
      'standard',
      'version',
      'videoBitRate',
      'videoBitRateUnits'
    ];
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-saw-files-naming-convention.ts